import { render } from "./OtherNavbar.vue?vue&type=template&id=ccaca79c&scoped=true"
import script from "./OtherNavbar.vue?vue&type=script&lang=js"
export * from "./OtherNavbar.vue?vue&type=script&lang=js"

import "./OtherNavbar.vue?vue&type=style&index=0&id=ccaca79c&scoped=true&lang=css"

import exportComponent from "/Users/fasa/JS/freelance/UgaldeYAsociados/gerardoyasociados-website-final/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccaca79c"]])

export default __exports__